/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "../../../../partials/datatable/Datatable";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../partials/datatable/styles";
import { SvgIcon, makeStyles } from "@material-ui/core";
import { globalColors } from "../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as iconUsers } from "../../../../assets/custom-icons/users-icon.svg";
import { ReactComponent as iconPlus } from "../../../../assets/icons/icon-plus-green.svg";
import { AppAPIService } from "../../../../services/AppAPIService";
import Loading from "../../../home/components/Loading";
import { UserRole } from "../../../../enums/UserRole";
import { ListingActionsEnum } from "../../../../enums/ListingActionsEnum";
import store from "../../../../store/store";
import { isXavierThemeV2Enabled } from "../../../../utils/FeatureFlags";

const UserListing = (props) => {
  let api = AppAPIService.getInstance();

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const [profiles] = useState([
    { value: UserRole.ADMIN, label: "Administrador" },
    { value: UserRole.COLLABORATOR, label: "Colaborador" },
    { value: UserRole.CLIENT, label: "Cliente" },
  ]);

  const [profileLabels] = useState({
    [UserRole.ADMIN]: "Administrador",
    [UserRole.COLLABORATOR]: "Colaborador",
    [UserRole.CLIENT]: "Cliente",
  });
  const { auth } = store.getState();

  window.setPageTitle("Listagem de Usuários - Admin");

  const useStyles = makeStyles((theme) => ({
    tooltip: {
      backgroundColor: globalColors.colorWhite,
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "12px",
      border: `1px solid ${globalColors.primaryColor4}`,
      marginRight: "30px",
    },
    arrow: {
      "&::before": {
        content: '""',
        position: "absolute",
        zIndex: -1,
        width: 0,
        height: 0,
        borderColor: "transparent",
        borderStyle: "solid",
        borderWidth: "7px",
        boxShadow: "-1px -1px 1px rgba(0, 0, 0, 0.1)",
      },
    },
  }));

  const applyMaskCpfCnpj = (value) => {
    if (!value) return value;
    if (value?.length < 11) {
      return value || "";
    } else if (value?.length >= 11 && value?.length < 14) {
      return value.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2}).*/,
        "$1.$2.$3-$4"
      );
    } else {
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
        "$1.$2.$3/$4-$5"
      );
    }
  };

  const handleResendMail = async (user) => {
    console.log("id", user.id);
    try {
      setLoading(true);
      const result = await api.makeHttpRequest({
        method: "PATCH",
        url: `/user/invite/${user.id}`,
      });

      setReload(!reload);
      setLoading(false);
      if (result?.invitationDelivery?.accepted !== true) {
        throw new Error("O provedor não confirmou o envio");
      }
      Swal.fire({
        title: "Sucesso!",
        text: "Email reenviado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao reenviar email.", "error");
    }

    setLoading(false);
  };
  
  const role = props.user?.role;

  const handleGetUserActions = (user) => {
    const actions = [];
    if (role === UserRole.ADMIN) {
      actions.push(ListingActionsEnum.EDIT)
      if (user?.activationStatus?.status === "INVITED") {
        actions.push(ListingActionsEnum.RESEND);
        actions.push(ListingActionsEnum.DELETE);
      } else {
        actions.push(ListingActionsEnum.TOGGLE);
      }
      return actions;
    } else if (role === UserRole.COLLABORATOR) {
      actions.push(ListingActionsEnum.EDIT);
      if (user?.activationStatus?.status === "INVITED") {
        actions.push(ListingActionsEnum.RESEND);
      }
    } else if (role === UserRole.CLIENT) {
      actions.push(ListingActionsEnum.EDIT);
    }
    return actions;
  };

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/user/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: "Sucesso!",
        text: "Usuário deletado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao deletar usuário.", "error");
    }

    setLoading(false);
  };

  const handleConfirmChangeStatus = async (obj) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/user/toggle/${obj.id}`,
        data: {
          active: !obj.active,
        },
      });

      setReload(!reload);

      const userStatus = !obj.active ? "ativado" : "desativado";

      Swal.fire({
        title: "Sucesso!",
        text: `Usuário ${userStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao alterar status.", "error");
    }
  };

  const headRows = [
    { column: "Options", label: "Ações", align: "center", sortable: false },
    { column: "name", label: "Nome", sortField: "username" },
    { column: "email", label: "Email" },
    { column: "cpf/CNPJ", label: "CPF/CNPJ", sortField: "cpfCnpj" },
    { column: "phone", label: "Telefone/Celular" },
    { column: "role", label: "Perfil" },
  ];

  const formatRow = (r) => {
    return (
      <StyledTableRow key={r.id} hover tabIndex={-1}>
        <StyledTableCell
          scope="row"
          style={{
            width: "35px",
            border: "none",
          }}
        >
          <CrudActions
            actions={handleGetUserActions(r)}
            module="usuario"
            onConfirmChangeStatus={handleConfirmChangeStatus}
            onConfirmDelete={handleConfirmDelete}
            onConfirmResendEmail={handleResendMail}
            onViewDetails={() => {
              window.location.href = `/admin/usuario/${r.id}/visualizar`;
            }}
            id={r.id}
            obj={r}
            titleMessageDelete={""}
            addMessage={"Deseja deletar esse usuário?"}
            align="start"
          />
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 0px",
            textAlign: "left",
            border: "none",
          }}
        >
          <span style={{ padding: " 0 7px", width: "170px" }}>
            {r.username}
          </span>
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 0px",
            textAlign: "left",
            border: "none",
          }}
        >
          <span style={{ padding: " 0 7px" }}>{r.email}</span>
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 0px",
            textAlign: "left",
            border: "none",
          }}
        >
          <span style={{ padding: " 0 7px" }}>{applyMaskCpfCnpj(r.cpfCnpj)}</span>
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 0px",
            textAlign: "left",
            width: "170px",
            border: "none",
          }}
        >
          <span style={{ padding: " 0 7px" }}>{r.phone}</span>
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{
            padding: "4px 0px",
            textAlign: "left",
            width: "170px",
            border: "none",
          }}
        >
          <span style={{ padding: " 0 7px" }}>
            {profileLabels[r.role]}
          </span>
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Datatable
        title="Usuários"
        hideTitle={isXavierThemeV2Enabled()}
        icon={
          <SvgIcon
            component={iconUsers}
            stroke={globalColors.primaryColor5}
            style={{
              fontSize: "24px",
              marginRight: "22px",
              marginLeft: "2px",
              fill: "none",
              fontWheight: "600",
            }}
          />
        }
        endpoint="/user/list-paginated"
        className="bg-white"
        headRows={headRows}
        formatRow={formatRow}
        rows={[{ column: "name", label: "Nome" }]}
        reload={reload}
        placeholderSearch="Busque por nome, e-mail ou CPF"
        width={props.width}
        selectInput={{
          label: "Perfil",
          title: "Selecione um perfil",
          options: profiles,
        }}
        tooltip="Cadastrar Novo Usuário"
        hiddenReload
        personInputs
        personStatusFilter={profiles}
        addButtonUrl="/admin/usuario/adicionar"
        hiddenKanbanContent
        colorButton={globalColors.transparent}
        titleButon={
          <SvgIcon
            component={iconPlus}
            alt="Cadastrar Novo Usuário"
            fill={globalColors.primaryColor1}
            viewBox="0 0 16 15"
            style={{
              width: "30px",
              height: "32px",
              fill: globalColors.primaryColor1,
              color: globalColors.primaryColor1,
              display: auth?.user?.role === "ADMIN" || auth?.user?.role === "COLLABORATOR" ? "block" : "none",
            }}
          />
        }
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(UserListing);
